<div class="agmo-breadcrumb">
  @for (route of routes; track route; let last = $last) {
    <div [routerLink]="getRouteUrl(route)" [ngClass]="last ? 'active' : 'link'">
      {{ getRouteTitle(route) }}
    </div>
    <div class="icon" [hidden]="last"><i class="fas fa-angle-right"></i></div>
  }
</div>
